import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles(() =>
  createStyles({
    cardLinkWrapper: { height: '100%', textDecoration: 'none' },
    cardRoot: { height: 'inherit' },
  })
)
